/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrayectoriaRouteImport } from './routes/trayectoria'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as AreasRouteImport } from './routes/areas'
import { Route as IndexRouteImport } from './routes/index'

const TrayectoriaRoute = TrayectoriaRouteImport.update({
  id: '/trayectoria',
  path: '/trayectoria',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactoRoute = ContactoRouteImport.update({
  id: '/contacto',
  path: '/contacto',
  getParentRoute: () => rootRouteImport,
} as any)
const AreasRoute = AreasRouteImport.update({
  id: '/areas',
  path: '/areas',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/areas': typeof AreasRoute
  '/contacto': typeof ContactoRoute
  '/trayectoria': typeof TrayectoriaRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/areas': typeof AreasRoute
  '/contacto': typeof ContactoRoute
  '/trayectoria': typeof TrayectoriaRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/areas': typeof AreasRoute
  '/contacto': typeof ContactoRoute
  '/trayectoria': typeof TrayectoriaRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/areas' | '/contacto' | '/trayectoria'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/areas' | '/contacto' | '/trayectoria'
  id: '__root__' | '/' | '/areas' | '/contacto' | '/trayectoria'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AreasRoute: typeof AreasRoute
  ContactoRoute: typeof ContactoRoute
  TrayectoriaRoute: typeof TrayectoriaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trayectoria': {
      id: '/trayectoria'
      path: '/trayectoria'
      fullPath: '/trayectoria'
      preLoaderRoute: typeof TrayectoriaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacto': {
      id: '/contacto'
      path: '/contacto'
      fullPath: '/contacto'
      preLoaderRoute: typeof ContactoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/areas': {
      id: '/areas'
      path: '/areas'
      fullPath: '/areas'
      preLoaderRoute: typeof AreasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AreasRoute: AreasRoute,
  ContactoRoute: ContactoRoute,
  TrayectoriaRoute: TrayectoriaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
